import { Link } from "react-router-dom";

export function NotFound() {
  return <section className="p-6 space-y-4">
    <h1 className="text-xl font-semibold">Página não encontrada</h1>
    <p>Verifique o endereço ou volte ao início para continuar.</p>
    <Link className="underline" to="/">Voltar ao início</Link>
  </section>;
}
